import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";

const Layout = () => {
  return (
    <div className="flex h-screen bg-[#fafafa] dark:bg-gray-950" data-testid="layout-container">
      <Sidebar />
      <main className="flex-1 overflow-auto bg-[#fafafa] dark:bg-gray-950">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
